import { Component } from '@angular/core';
import { LoginComponent, LoginMode } from "./login.component";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'msh-authenticate',
  imports: [LoginComponent],
  standalone: true,
  template: `
    <div class="py-16">
      <msh-login [mode]="mode" ></msh-login>
    </div>
  `,
  styles: ``
})
export class AuthenticateComponent {
  mode: LoginMode = 'login';
  constructor(
    private route: ActivatedRoute,
  ){
    console.log({data: route.snapshot.data})
    if( route.snapshot.data &&  route.snapshot.data['signup']){
      this.mode = "signup";
    }
  }

}
